/**
 * Maintenance mode. While the platform is being updated, the API answers every call with HTTP 200 and
 *   { statusCode: 503, maintenance: true, message: "We're updating the platform…" }
 * (nginx switch on the API server, see FitClub-Backend/deploy/maintenance/README.md). The web app then shows
 * public/maintenance.html instead of half-working pages or error pop-ups; "Try again" brings people back.
 * The iOS / Android apps show the same message from the response in their normal error alert.
 */
export const MAINTENANCE_PAGE = "/maintenance.html";

export const isMaintenanceResponse = (data) => !!data && data.maintenance === true && Number(data.statusCode) === 503;

export function showMaintenancePage() {
  if (typeof window === "undefined" || window.location.pathname === MAINTENANCE_PAGE) return;
  const from = `${window.location.pathname}${window.location.search}`;
  window.location.replace(`${MAINTENANCE_PAGE}?from=${encodeURIComponent(from)}`);
}

/** Adds the check to an axios instance (the shared axiosInstance, and the default axios used by raw calls). */
export function watchForMaintenance(instance) {
  instance.interceptors.response.use(
    (response) => {
      if (isMaintenanceResponse(response?.data)) showMaintenancePage();
      return response;
    },
    (error) => {
      if (isMaintenanceResponse(error?.response?.data)) showMaintenancePage();
      return Promise.reject(error);
    }
  );
}
